import { render } from "./platform_features.html?vue&type=template&id=fc24e174&external"
import script from "./platform_features.js?vue&type=script&lang=js&external"
export * from "./platform_features.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__